module.exports = __webpack_public_path__ + "img/background.a5297168.svg";